import { Injectable, Injector } from '@angular/core';
import { FeatureManagementServiceProxy } from "shared/service-proxies/service-proxies";

@Injectable()
export class FeatureFlagService {

    private _featureManagementServiceProxy: FeatureManagementServiceProxy
    private _featureFlags: Array<string> = [];
    private _initialized = false;

    constructor(injector: Injector) {
        this._featureManagementServiceProxy = injector.get(FeatureManagementServiceProxy);
    }

    featureOff(featureName: string) {
        return !this.featureOn(featureName);
    }

    featureOn(featureName: string) {
        if (!featureName) {
            return true;
        }

        return this._featureFlags && !!this._featureFlags.find(feature => {
            return feature === featureName;
        });
    }

    get initialized() {
        return this._initialized;
    }

    getFeatureFlags(): Promise<Array<string>> {
        return this._featureManagementServiceProxy.getAllEnabledFeatures()
            .toPromise();
    }

    initialize() {
        this._featureFlags = [];
        return new Promise((resolve, reject) => {
            this.getFeatureFlags()
                .then(featureFlags => {
                    this._featureFlags = featureFlags;
                    this._initialized = true;
                    //resolve();
                })
                .catch((e) => {
                    //resolve();
                });
        });
    }
}
